import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52c35d22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categories-tree-item-content d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-1 mb-1" }, "chevron_right", -1))
const _hoisted_3 = {
  class: "align-middle",
  style: {"width":"120px"}
}
const _hoisted_4 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_6 = ["data-dp-tooltip"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "btn btn-icon ms-2",
  style: {"visibility":"hidden"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-primary",
  style: {"visibility":"hidden"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-danger ms-2",
  style: {"visibility":"hidden"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_offcanvas_button_open = _resolveComponent("base-offcanvas-button-open")!
  const _component_CustomerCategoryNode = _resolveComponent("CustomerCategoryNode", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", {
        style: _normalizeStyle(_ctx.paddingStyle),
        class: "align-middle"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.hasChildren)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                role: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOpen(_ctx.treeNode.code))),
                class: _normalizeClass([{ open: _ctx.isOpen }, "name d-flex align-items-center text-decoration-none lh-1"])
              }, [
                _hoisted_2,
                _createElementVNode("span", {
                  class: _normalizeClass({ 'fw-600 fs-5': _ctx.isFirstLevel })
                }, _toDisplayString(_ctx.treeNode.name), 3)
              ], 2))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(["name m-0 ps-4", { 'fw-600 fs-5': _ctx.isFirstLevel }])
              }, "  " + _toDisplayString(_ctx.treeNode.name), 3))
        ])
      ], 4),
      _createElementVNode("td", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.canEdit)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_base_offcanvas_button_open, {
                  "offcanvas-id": "offcanvas-customer-category",
                  class: "btn btn-icon btn-primary",
                  onBeforeOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('editCategory', _ctx.treeNode.customerCategory)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                (_ctx.canDelete)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('deleteCategory', _ctx.treeNode.customerCategory))),
                      class: "btn btn-icon btn-danger ms-2",
                      "data-dp-tooltip": _ctx.$t('delete'),
                      "data-dp-position": "left"
                    }, _hoisted_8, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_12,
                _hoisted_13
              ], 64))
        ])
      ])
    ]),
    (_ctx.hasChildren && _ctx.isOpen)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.treeNode.children, (child) => {
          return (_openBlock(), _createBlock(_component_CustomerCategoryNode, {
            key: child.code,
            "tree-node": child,
            level: _ctx.level + 1,
            open: _ctx.open,
            onToggleOpen: _ctx.toggleOpen,
            onEditCategory: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('editCategory', $event))),
            onDeleteCategory: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('deleteCategory', $event)))
          }, null, 8, ["tree-node", "level", "open", "onToggleOpen"]))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}